
export class LOVConventionLanguageExtension {
}
